import { InputHTMLAttributes, PropsWithChildren, Ref } from "react"

import { join } from "@/utils/join"

import { ChevronIcon } from "../icons"

interface Props {
  name?: string
  id?: string
  value?: string
  comboBox?: boolean
  className?: string
  valid?: boolean
  ref?: Ref<HTMLInputElement>
}

export const Input = ({
  comboBox,
  ref,
  valid = true,
  children,
  className,
  ...props
}: PropsWithChildren<InputHTMLAttributes<HTMLInputElement> & Props>) => {
  const borderClass = valid ? "border-secondary" : "border-error"
  const baseClass =
    "text-md-regular density-md text-primary px-sm placeholder:text-placeholder m-0 w-full border"
  const stateClasses = "outline-none focus:ring-[1.5px] focus:ring-focus-ring"

  return (
    <div className="relative flex items-center">
      <input
        className={join(
          baseClass,
          props.disabled
            ? "bg-secondary_subtle"
            : join("bg-secondary", stateClasses),
          borderClass,
          className,
        )}
        ref={ref}
        {...props}
      />
      {children}
      {comboBox && (
        <div className="absolute right-1 text-tertiary">
          <ChevronIcon />
        </div>
      )}
    </div>
  )
}
